import clsx from 'clsx';
import React from 'react';
import { FIREBOLT_DESTINATION_CONSIDERATIONS_DOC_LINK } from '../constants/constants';
import { HdDocLink, HdIcon } from '../../../components';
import styles from './styles.module.scss';

export function FireboltSchemaBuilderHelperPane() {
  return (
    <div className={clsx('border-left', styles.fieldInfoToolContainer)}>
      <div className='h-100'>
        <div className='h-100'>
          <div className={clsx(styles.warningContainer, 'd-flex px-3 py-2 mb-0')}>
            <HdIcon name='warning' className='icon-with-text text-warning mr-2' />

            <div>
              <div className='warning-wrapper mb-1'>
                Once a table is created, Firebolt does not allow you to add or
                delete columns.
              </div>

              <HdDocLink
                dataId='schema-builder-firebolt-destination-considerations'
                section='firebolt_destination_considerations'
                docLink={FIREBOLT_DESTINATION_CONSIDERATIONS_DOC_LINK}
              />
            </div>
          </div>

          <div className='p-4'>
            <div className='mb-5'>
              <div className='text-medium mb-1'>Primary Index (PI)</div>
              The primary indexes are the main sort key of the table. In partitioned
              tables, the partition key column will be the first line of data
              distribution. The primary index will be used in each partition as the
              second level of sort/distribution.
            </div>

            <div className='mb-5'>
              <div className='text-medium mb-1'>Partition Key (PRK)</div>
              Partitions are multiple smaller physical parts of large tables, being
              created for data maintenance and performance. They are only supported
              on FACT tables.
            </div>

            <div className='mb-5'>
              <div className='text-medium mb-1'>Nullable Column (NC)</div>
              Aggregate indices can not be created on nullable columns. Mark column
              as non-nullable, if you plan to make Primary, Aggregating, or Join
              indexes out of it.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
